/* tslint:disable */
/* eslint-disable */
// <auto-generated>
//   Generated using custom tool!
// </auto-generated>

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { DefaultAxiosInstance } from './DefaultAxiosInstance';
import { Try } from '../framework/Try';
import { INamedProperty } from './INamedProperty';

export async function meta_build(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/meta/build";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function meta_ping(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<void>> {
  try {

        let url_ = "/api/meta/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function meta_url(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/meta/url";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_new(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/RequestsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_setLoad(id: string, body: IContactWithAddressModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IContactWithAddressModel>>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/load";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_setLoadTime(id: string, body: ITimeModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ITimeModel>>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/load/time";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_setCargo(id: string, body: ICargoModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ICargoModel>>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/cargo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_setTruck(id: string, body: ITruckModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ITruckModel>>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/truck";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_setUnload(id: string, body: IContactWithAddressModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IContactWithAddressModel>>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/unload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_saveForLater(id: string, body: IContactModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IContactModel>>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/saveForLater";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_confirm(id: string, body: IContactModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IContactModel>>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/confirm";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsQuery_single(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRequest>> {
  try {

        let url_ = "/api/RequestsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trucksQuery_all(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<ITruckDto[]>>> {
  try {

        let url_ = "/api/TrucksQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function trucksQuery_concurrencyToken(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/TrucksQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function vavatoRequestsCommand_new(body: IVavatoModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function vavatoRequestsCommand_newNested(body: IVavatoNestedModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/new/nested";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export interface IContactWithAddressModel {
    personOnSite: string | undefined;
    companyName: string | undefined;
    phoneNumber: string | undefined;
    street: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    country: string | undefined;
    number: string | undefined;
    extraInfo: string | undefined;
}

export interface ITimeModel {
    date: Date;
    afterDate: Date | undefined;
    beforeDate: Date | undefined;
}

export interface ICargoModel {
    lengthInCm: number;
    widthInCm: number;
    heightInCm: number;
    description: string | undefined;
    weightInKg: number;
}

export interface ITruckModel {
    truckId: number;
    description: string | undefined;
    pictureAttachmentId: string | undefined;
}

export interface IContactModel {
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    vatNumber: string | undefined;
}

export interface IEasyTransResponseSummary {
    id: number;
    hasRateWarnings: boolean;
    priceInVat: number | undefined;
}

export interface IRequest {
    id: string;
    created: Date;
    lastUpdated: Date;
    loadModel: IContactWithAddressModel;
    loadTime: ITimeModel;
    cargoModel: ICargoModel;
    truckModel: ITruckModel;
    unloadModel: IContactWithAddressModel;
    unloadTime: ITimeModel;
    contactModel: IContactModel;
    easyTransResponse: IEasyTransResponseSummary;
    isSavedForLater: boolean;
    assignedTruckId: number | undefined;
    isConfirmed: boolean;
    vavatoUrl: string | undefined;
    vavatoDescription: string | undefined;
    hasCargoModelFromVavato: boolean;
    hasLoadModelFromVavato: boolean;
    hasUnloadModelFromVavato: boolean;
    isFromVavato: boolean;
    hasRateWarnings: boolean;
    price: number | undefined;
    easyTransOrderId: number | undefined;
    hasEasyTransResponse: boolean;
    hasPrice: boolean;
    selectedOrAssignedTruckId: number | undefined;
    hasLoadModel: boolean;
    hasLoadTimeModel: boolean;
    hasCargoModel: boolean;
    hasUnloadModel: boolean;
    hasContactModel: boolean;
    hasTruckModel: boolean;
    hasSelectedOrAssignedTruckId: boolean;
    canCalculateOrderAndPrice: boolean;
    formattedLoadModel: string | undefined;
    formattedLoadTimeModel: string | undefined;
    formattedCargoModel: string | undefined;
    formattedUnloadModel: string | undefined;
    formattedContactModel: string | undefined;
    description: string | undefined;
}

export interface ITruckDto {
    id: number;
    name: string | undefined;
    length: number;
    width: number;
    height: number;
    countEuroPallets: number;
    maxLoad: number;
    base64Image: string | undefined;
    volume: number;
    lengthInCm: number;
    widthInCm: number;
    heightInCm: number;
    display: string | undefined;
}

export interface IVavatoModel {
    url: string | undefined;
    loadPersonOnSite: string | undefined;
    loadCompanyName: string | undefined;
    loadPhoneNumber: string | undefined;
    loadStreet: string | undefined;
    loadZip: string | undefined;
    loadCity: string | undefined;
    loadCountry: string | undefined;
    loadHouseNumber: string | undefined;
    loadExtraInfo: string | undefined;
    date: Date;
    afterDate: Date | undefined;
    beforeDate: Date | undefined;
    lengthInCm: number;
    widthInCm: number;
    heightInCm: number;
    weightInKg: number;
    description: string | undefined;
    unloadPersonOnSite: string | undefined;
    unloadCompanyName: string | undefined;
    unloadPhoneNumber: string | undefined;
    unloadStreet: string | undefined;
    unloadZip: string | undefined;
    unloadCity: string | undefined;
    unloadCountry: string | undefined;
    unloadHouseNumber: string | undefined;
    unloadExtraInfo: string | undefined;
    contactEmail: string | undefined;
    contactFirstName: string | undefined;
    contactLastName: string | undefined;
    contactPhoneNumber: string | undefined;
    contactVatNumber: string | undefined;
}

export interface IVavatoCargoModel {
    lengthInCm: number;
    widthInCm: number;
    heightInCm: number;
    weightInKg: number;
}

export interface IVavatoNestedModel {
    url: string | undefined;
    description: string | undefined;
    load: IContactWithAddressModel;
    loadTime: ITimeModel;
    unload: IContactWithAddressModel;
    cargo: IVavatoCargoModel;
    contact: IContactModel;
}


export interface IQueryResult<T> {
    values: T[];
    unfilteredCount: number;
    filteredCount: number;
    pageIndex: number;
    pageSize: number;
    concurrencyToken: number;
    zeroBasedPageIndex: number;
    totalPages: number;
    currentFrom: number;
    currentTo: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}


export interface IQueryResultWithMetadata<T, TMetadata> {
    values: T[];
    unfilteredCount: number;
    filteredCount: number;
    pageIndex: number;
    pageSize: number;
    concurrencyToken: number;
    zeroBasedPageIndex: number;
    totalPages: number;
    currentFrom: number;
    currentTo: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    metadata: TMetadata;
}


export interface IObjectWithIdAndIdentifier<T> {
    id: T;
    identifier: string;
}


export interface IConcurrencyData<T> {
    value: T;
    concurrencyToken: number;
}


export interface ICreateResponse<T> {
    objectId: string;
    errors: IValidationError<T>[];
    hasError: boolean;
    isSuccess: boolean;
}


export interface IUpdateResponse<T> {
    errors: IValidationError<T>[];
    hasError: boolean;
    isSuccess: boolean;
}


export interface IValidationError<T> {
    property: string;
    error: string;
    zeroBasedIndex: number | undefined;
}


export interface IExportParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}


export interface ISortParams<T> {
    property: keyof T;
    direction: 'asc' | 'desc'
}

export type IFileResponse = { }

export type IBlob = { }


export type LanguageOption = 'nl' | 'en' | 'fr';
export const LanguageOptions: LanguageOption[] = ['nl', 'en', 'fr'];